import { Pointers } from "@opendaw/studio-enums";
import { Devices } from "../../DeviceAdapter";
import { IndexedBoxAdapterCollection } from "../../IndexedBoxAdapterCollection";
import { PlayfieldSampleBoxAdapter } from "./Playfield/PlayfieldSampleBoxAdapter";
import { ParameterAdapterSet } from "../../ParameterAdapterSet";
import { TrackType } from "../../timeline/TrackType";
export class PlayfieldDeviceBoxAdapter {
    type = "instrument";
    accepts = "midi";
    #context;
    #box;
    #samples;
    #parametric;
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#samples = IndexedBoxAdapterCollection.create(box.samples, box => context.boxAdapters.adapterFor(box, PlayfieldSampleBoxAdapter), Pointers.Sample);
        this.#parametric = new ParameterAdapterSet(this.#context);
    }
    reset() { this.#samples.adapters().forEach(adapter => adapter.box.delete()); }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get notesAddress() { return this.#box.address.append(1000); }
    get labelField() { return this.#box.label; }
    get iconField() { return this.#box.icon; }
    get defaultTrackType() { return TrackType.Notes; }
    get enabledField() { return this.#box.enabled; }
    get minimizedField() { return this.#box.minimized; }
    get acceptsMidiEvents() { return true; }
    get samples() { return this.#samples; }
    get context() { return this.#context; }
    deviceHost() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.host.targetVertex.unwrap("no device-host").box, Devices.isHost);
    }
    audioUnitBoxAdapter() { return this.deviceHost().audioUnitBoxAdapter(); }
    terminate() { this.#parametric.terminate(); }
}
